// extracted by mini-css-extract-plugin
export var addressFields = "_n1-0";
export var animationContainer = "_n1-1";
export var footer = "_n1-2";
export var lineItems = "_n1-3";
export var modalContent = "_n1-4";
export var orderName = "_n1-5";
export var strong = "_n1-6";
export var warning = "_n1-7";